import { IDashboard } from 'pages/Dashboard';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings';
import { getCookie } from 'shared/utils/getCookie';

export const dasboardApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getDashboard: builder.query<IDashboard, void>({
				query: () => ({
					url: `dashboard/`,
				}),
			}),

			closeBanners: builder.mutation<null, void>({
				query() {
					return {
						url: `dashboard/banners/close/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
					};
				},
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.DASHBOARD],
		endpoints: {
			getDashboard: {
				providesTags: [EApiTags.DASHBOARD],
			},
			closeBanners: {
				invalidatesTags: [EApiTags.DASHBOARD],
			},
		},
	});

export const { useGetDashboardQuery, useCloseBannersMutation } = dasboardApi;
